var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FCE8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9668 39.9999L37.9835 44.0332L46.0335 35.9666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9168 24.0834C39.0668 23.1001 40.9501 23.1001 42.1168 24.0834L44.7501 26.3501C45.2501 26.7834 46.1835 27.1334 46.8501 27.1334H49.6835C51.4501 27.1334 52.9001 28.5834 52.9001 30.3501V33.1834C52.9001 33.8334 53.2501 34.7834 53.6835 35.2834L55.9501 37.9168C56.9335 39.0668 56.9335 40.9501 55.9501 42.1168L53.6835 44.7501C53.2501 45.2501 52.9001 46.1834 52.9001 46.8501V49.6834C52.9001 51.4501 51.4501 52.9001 49.6835 52.9001H46.8501C46.2001 52.9001 45.2501 53.2501 44.7501 53.6834L42.1168 55.9501C40.9668 56.9334 39.0835 56.9334 37.9168 55.9501L35.2835 53.6834C34.7835 53.2501 33.8501 52.9001 33.1835 52.9001H30.3001C28.5335 52.9001 27.0835 51.4501 27.0835 49.6834V46.8334C27.0835 46.1834 26.7335 45.2501 26.3168 44.7501L24.0668 42.1001C23.1001 40.9501 23.1001 39.0834 24.0668 37.9334L26.3168 35.2834C26.7335 34.7834 27.0835 33.8501 27.0835 33.2001V30.3334C27.0835 28.5668 28.5335 27.1168 30.3001 27.1168H33.1835C33.8335 27.1168 34.7835 26.7668 35.2835 26.3334L37.9168 24.0834Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.01fb7f489347fb2ff163890259972e11.svg";
export { ForwardRef as ReactComponent };